import logo from './logo.svg';
import './App.css';
import NailCourseSyllabus from './components/Sillabus/Sillabus';
import HeroSection from './screens/FirstScreen';
import SecondScreen from './screens/SecondScreen';
import ThirdScreen from './screens/ThirdScreen';
import ForthScreen from './screens/ForthScreen';
import FifthScreen from './screens/FifthScreen';
import ByMe from './components/ByMe/ByMe';
import PrivacyPolicy from './components/privacy/Privacy';
import NavBarNew from './components/CourseNav/NavBarNew';
import FloatingWhatsAppButton from './components/FloatingButton/FloatingButton';

function App() {
  return <>
  <NavBarNew/>
  <HeroSection/>
  <SecondScreen/>
  <ThirdScreen/>
   <ForthScreen/>
  <NailCourseSyllabus/>
 <FifthScreen/>
       <PrivacyPolicy 
                      ownerName="אסתר מטטוב" 
                      email="Estermati10@gmail.com" 
                      phone="0508810622" 
                      domain="https://estermatiacademy.co.il/" 
                    />
                    <FloatingWhatsAppButton/>
<ByMe/>
  </>
}

export default App;
